import { getNftDetails } from 'helpers/asyncRequests'
import React from 'react'
import './stakedNftComponent.css'

const StakedNft = (d) => {
    const [isSelected, setIsSelected] = React.useState(false)
    const [mounted, setMounted] = React.useState(false)
    const [imgUrl, setImgUrl] = React.useState('')

    const handleSelection = () => {
        setIsSelected(!isSelected)
        d.onClickHandle()
    }

    React.useEffect(() => {
        getNftDetails(d.nft.tokenIdentifier, parseInt(d.nft.nonce)).then(
            (res) => {
                setImgUrl(res.data.url)
                setMounted(true)
            }
        )
    }, [])

    return (
        mounted && (
            <div
                className={isSelected ? 'nft-staked-selected' : 'nft-staked'}
                onClick={handleSelection}
            >
                {/* {d.nft.tokenIdentifier}-{d.nft.nonce} ({d.nft.dailyReward} $NGMI daily) */}
                <img src={imgUrl} alt="" height="50px" />
            </div>
        )
    )
}

export default StakedNft
